<template>
  <div class="view partners">
    <section class="banner">
      <div class="banner-background">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1404" viewBox="0 0 1900 1404"><defs><clipPath id="pb-a"><rect width="1900" height="1404" fill="#fff"/></clipPath><linearGradient id="pb-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ba146d"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#ba146d"/><stop offset="1" stop-color="#880f50"/></linearGradient><linearGradient id="pb-c" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ba146d"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><filter id="pb-d" x="-996.427" y="-1678.665" width="3024.7" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#pb-a)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#pb-b)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#pb-d)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#pb-c)"/></g></g></svg>
      </div>
      <svg v-if="!isMobile" class="banner-bubbles" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="875" height="541.958" viewBox="0 0 875 541.958"><defs><filter id="pbb-a" x="789.153" y="111.022" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="pbb-c" x="577.073" y="0" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="pbb-e" x="618.152" y="89.958" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><filter id="pbb-g" x="62" y="468.958" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="h"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter><filter id="pbb-i" x="0" y="429.958" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-815.5 -318.542)"><g transform="matrix(1, 0, 0, 1, 815.5, 318.54)" filter="url(#pbb-a)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 826.25, 156.37)" fill="#d4177c"/></g><g transform="matrix(1, 0, 0, 1, 815.5, 318.54)" filter="url(#pbb-c)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 612.21, 38.79)" fill="#d4177c"/></g><g transform="matrix(1, 0, 0, 1, 815.5, 318.54)" filter="url(#pbb-e)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(646.65 106.46)" fill="#d4177c"/></g><g transform="matrix(1, 0, 0, 1, 815.5, 318.54)" filter="url(#pbb-g)"><circle cx="8" cy="8" r="8" transform="translate(90.5 485.46)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 815.5, 318.54)" filter="url(#pbb-i)"><circle cx="17" cy="17" r="17" transform="translate(28.5 446.46)" fill="#d4177c"/></g></g></svg>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="232.667" height="232.666" viewBox="0 0 232.667 232.666"><defs><filter id="phs-a" x="0" y="0" width="232.667" height="232.666" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="phs-c" x="136.092" y="112.391" width="78.213" height="78.213" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="phs-e" x="4.57" y="105.32" width="78.213" height="78.213" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(110.145 -463.665) rotate(45)"><g transform="matrix(0.71, -0.71, 0.71, 0.71, 249.98, 405.74)" filter="url(#phs-a)"><path d="M71.59-7.113C113.855-11.551,96.762,21.832,120,60s-3.5,74.168-54.793,54.457S-4.125,96.16,15.039,60,29.324-2.676,71.59-7.113Z" transform="translate(108.02 16.46) rotate(45)" fill="#d4177c"/></g><g transform="matrix(0.71, -0.71, 0.71, 0.71, 249.98, 405.74)" filter="url(#phs-c)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(175.2 128.89) rotate(45)" fill="#d4177c"/></g><g transform="matrix(0.71, -0.71, 0.71, 0.71, 249.98, 405.74)" filter="url(#phs-e)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(43.68 121.82) rotate(45)" fill="#d4177c"/></g></g></svg>
          <h1>Partners</h1>
          <p v-if="page" v-html="page.headline.replace(/\n/g, '<br>')"></p>
        </div>
      </div>
      <div class="page-photo">
        <img class="edge" v-if="!isMobile" src="@/assets/cast_partners_photo.png">
        <svg class="not-edge" v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1531.281" height="468.784" viewBox="0 0 1531.281 468.784"><defs><pattern id="pp-a" width="1" height="1" viewBox="921.348 -0.505 468.784 1531.281"><image preserveAspectRatio="xMidYMid slice" width="2043.115" height="1531.281" :xlink:href="require('@/assets/shapes/partners_photo-image.jpg')"/></pattern></defs><path d="M-7491.077,844.946c-108.638-53.268-222.409,240.73-197.876,602.332s180.6,826.763,296.01,909.019,169.793-218.883,169.4-576.75S-7382.439,898.213-7491.077,844.946Z" transform="translate(2369.966 7692.324) rotate(90)" fill="url(#pp-a)"/></svg>
      </div>
      <div class="wrapper">
        <div class="picture-alt">Lara Beach, Cyprus</div>
      </div>
    </section>
    <section class="partners-section">
      <div class="wrapper">
        <div class="section-description">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="256" height="199.616" viewBox="0 0 256 199.616"><defs><linearGradient id="psb-a" x1="0.568" y1="-0.155" x2="0.851" y2="1.118" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ba146d"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><linearGradient id="psb-b" x1="0.5" y1="0" x2="0.5" y2="1" xlink:href="#psb-a"/></defs><g transform="translate(1070.633 1063.494) rotate(-180)" opacity="0.08"><path d="M78.286,0c38.032-2.715,73.84,26.392,73.84,72.346s-37.378,79.368-81.258,86.714S0,129.159,0,83.206,40.255,2.715,78.286,0Z" transform="translate(854.594 882.045)" fill="url(#psb-a)"/><path d="M24.39.018c12.146-.472,23.835,8.347,24.2,21.79s-11.325,22.9-25.305,24.677S.375,37.137.008,23.694,12.244.49,24.39.018Z" transform="translate(1030.627 929.574) rotate(-121)" fill="url(#psb-b)"/><path d="M15.683.031C23.3-.45,30.475,4.711,30.475,12.861S22.987,26.936,14.2,28.239,0,22.936,0,14.787,8.064.513,15.683.031Z" transform="translate(814.633 930.693) rotate(-90)" fill="url(#psb-b)"/><ellipse cx="6.602" cy="7.017" rx="6.602" ry="7.017" transform="translate(873.458 1049.459)" fill="url(#psb-b)"/></g></svg>
          <h2>Project Partners</h2>
        </div>
        <div class="partners-list">
          <a :href="(partner.link.startsWith('http') ? '' : 'http://') + partner.link" target="_blank" class="partner" v-for="partner in partners" :key="partner.id">
            <!-- <i class="fas fa-image"></i> -->
            <img :src="partner.image" :alt="partner.name">
            <div class="link">Visit website <i class="ic ic-link"></i></div>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'partners',
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    })
  },
  data() {
    return {
      partners: [],
      page: null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('partners').onSnapshot(page => {
      this.page = page.data()
    })
    this.partnersRef = this.db().collection('partners').orderBy('order').onSnapshot(partners => {
      this.partners = partners.docs.map(doc => doc.data())
      this.preloadImages([
        require('@/assets/shapes/partners_photo-image.jpg')
      ])
      .then(() => {
        this.$store.commit('setPageLoading', false)
      })
      .catch(() => {
        this.$store.commit('setPageLoading', false)
      })
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
    if(this.partnersRef) this.partnersRef()
  }
}
</script>

<style scoped>
.partners {
  /* background: url(../assets/cast_partners_banner.jpg) no-repeat top center/1920px auto; */
  padding-top: 222px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .banner-bubbles {
  position: absolute;
  top: 225px;
  right: 198px;
  width: 838px;
  height: 505px;
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 800px;
}

.page-title svg {
  position: absolute;
  top: -70px;
  left: 90px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #F77E0B;
}

.page-photo {
  position: relative;
  width: 1531px;
  max-width: 100%;
  margin: 26px auto 0;
}

.page-photo svg {
  display: block;
  width: 100%;
}

.partners-section {
  margin-top: 64px;
}

.banner .picture-alt {
  margin-top: 10px;
  text-align: center;
  color: #BCBCCB;
  text-transform: uppercase;
  letter-spacing: .58em;
  font-size: .72em;
}

.section-description {
  position: relative;
}

.section-description svg {
  position: absolute;
  top: -210px;
  left: 0;
}

section h2 {
  font: bold 3.21em/1 'Butler';
}

section h2:after {
  content: '';
  display: block;
  width: 74px;
  height: 1px;
  background: currentColor;
  margin-top: 20px;
}

.partners h2 {
  color: #880F50;
  margin-bottom: 20px;
}

.partners .partners-list {
  display: flex;
  flex-flow: row wrap;
  margin: 0 -8px 68px;
}

.partners .partners-list .partner {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 256px;
  height: 256px;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0,0,0,.06);
  background: #fff;
  margin: 0 8px 54px;
}

.partners .partners-list .partner img {
  width: 81.25%;
}

.partners .partners-list .partner i {
  font-size: 3.71em;
  color: #F7F7F7;
}

.partners .partners-list .partner .link {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  color: #880F50;
  font-size: .72em;
  letter-spacing: .58em;
  text-transform: uppercase;
  line-height: 1;
  opacity: 0;
  transition: all .16s ease-out;
  text-align: center;
}

@media screen and (min-width: 1025px) {
  .partners .partners-list .partner:hover .link {
    opacity: 1;
    transform: translateY(20px);
  }
}

.partners .partners-list .partner .link .ic {
  width: 10px;
  height: 10px;
}

@media screen and (max-width: 1024px) {
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color:#880F50;
    height: 48px;
  }
  .page-title p {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #880F50;
  }
  .banner .picture-alt {
    display: none;
  }
  .partners h2 {
    font-size: 28px;
  }
  .partners-section {
    margin-top: 72px;
  }
  .partners .partners-list .partner {
    width: calc(33.3333333% - 16px);
    height: calc(33.333333vw - 32px);
    margin-bottom: 32px;
  }
  .partners .partners-list .partner .link {
    top: auto;
    bottom: 12px;
    opacity: 1;
  }
  .partners .partners-list .partner .link i {
    vertical-align: baseline;
  }
}

@media screen and (max-width: 680px) {
  .partners {
    padding-top: 172px;
  }
}

@media screen and (max-width: 650px) {
  .partners .partners-list .partner {
    width: calc(50% - 8px);
    height: calc(50vw - 32px);
    margin: 0 4px 32px;
  }
  .partners .partners-list .partner .link {
    letter-spacing: .48em;
  }
}

@media screen and (max-width: 410px) {
  .partners .partners-list .partner {
    width: 100%;
    height: calc(100vw - 48px);
    margin: 0 0 24px;
  }
}
</style>
